import React from 'react';
import ReactHowler from 'react-howler';
import { usePreGenAudioPlayer } from '../zustand-store/usePreGenAudioPlayerStore';

export const PreGenAudioPlayer = () => {

    const { src, isPlaying, html5, stop, clearLoading } = usePreGenAudioPlayer((state) => state)

    if (src === null) {
        return <></>
    }

    return (
        <ReactHowler
            src={src}
            html5={html5}
            playing={isPlaying}
            onPlay={clearLoading}
            onLoadError={clearLoading}
            onPlayError={clearLoading}
            onEnd={() => {
                stop()
            }}
        />
    )
}
